import React, { useState } from 'react';
import NewMission from './components/NewMission';
import EditMission from './components/EditMission';
import MissionsList from './components/MissionsList';
import { Col, Container, Row } from 'react-bootstrap';

const Missions = () => {
  const [selectedMission, setSelectedMission] = useState();
  const [listRequiresReload, setListRequiresReload] = useState(true);

  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Missions Management</h3>
          <h3 className="page-subhead subhead">Manage workspace missions</h3>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <MissionsList setSelectedMission={setSelectedMission} setListRequiresReload={setListRequiresReload} listRequiresReload={listRequiresReload} />
        </Col>
        <Col md={4}>
          {!selectedMission && <NewMission setSelectedMission={setSelectedMission} setListRequiresReload={setListRequiresReload} selectedMission={selectedMission} />}
          {selectedMission && <EditMission setSelectedMission={setSelectedMission} setListRequiresReload={setListRequiresReload} selectedMission={selectedMission} />}
        </Col>
      </Row>
    </Container>
  );
};

export default Missions;